import type { Id } from '@odhaczka/core';
import { useLiveQuery } from 'dexie-react-hooks';
import { buildMergeMap, resolveWith } from '../../data/products';
import { db } from '../../db/db';

/**
 * Mapowanie scalonych produktów na ostateczne id — to samo, którego używa useStoreModel.
 * Bez niego pozycja ze scalonym produktem trafiałaby zawsze do „gdzieś po drodze”.
 */
export function useProductResolver(): ((id: Id) => Id) | undefined {
  return useLiveQuery(async () => resolveWith(buildMergeMap(await db.products.toArray())));
}
